import { FC } from 'react'
import { TextInput } from 'react-admin'

interface PropTypes {
  fieldId: string
  source: string
}

const TextFilter: FC<PropTypes> = ({ source, fieldId }) => {
  return (
    <TextInput
      label={false}
      source={`${source}.value.${fieldId}`}
      variant="outlined"
      margin={'none'}
    />
  )
}

export default TextFilter

